export const deliveryHours = {
    state: {
        deliveryHours: []
    },
    mutations: {
        SET_DELIVERYHOURS(state, deliveryHours) {
            state.deliveryHours = deliveryHours
        }
    },
    actions: {
        fetchDeliveryHours({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/management/delivery_hours').then(response => {
                    commit('SET_DELIVERYHOURS', response.data.data)
                    resolve()
                })
            })
        }
    },
    getters: {
        deliveryHours: (state) => {
            return state.deliveryHours
        }
    }
}
